import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Heart } from "lucide-react";
import api, { fileUrl } from "@/lib/api";
import { useFavorites } from "@/hooks/useFavorites";
import { Button } from "@/components/ui/button";

export default function MyFavorites() {
  const { t } = useTranslation();
  const nav = useNavigate();
  const { favs, toggle } = useFavorites();
  const [acts, setActs] = useState([]);

  useEffect(() => { api.get("/activities").then((r) => setActs(r.data.activities)).catch(() => {}); }, []);

  const shown = acts.filter((a) => favs.includes(a.id));

  return (
    <div className="section-sand min-h-[80vh] py-12 px-4" data-testid="my-favorites-page">
      <div className="max-w-6xl mx-auto">
        <h1 className="font-heading font-extrabold text-4xl text-ink mb-6 flex items-center gap-2"><Heart className="w-8 h-8 fill-red-500 text-red-500" /> {t("activities.favTitle")}</h1>
        {shown.length === 0 ? (
          <div className="text-center py-16" data-testid="my-favorites-empty">
            <p className="text-muted2 font-body mb-4">{t("activities.favEmpty")}</p>
            <Button onClick={() => nav("/activites")} className="rounded-full bg-canard hover:bg-canard-dark font-bold">{t("activities.title")}</Button>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {shown.map((a) => (
              <div key={a.id} data-testid={`fav-activity-${a.id}`} className="relative bg-white rounded-2xl border border-border overflow-hidden shadow-card">
                <button data-testid={`fav-remove-${a.id}`} onClick={() => toggle(a.id)} aria-label="remove" className="absolute top-3 right-3 z-10 w-9 h-9 rounded-full bg-white/90 shadow-sm flex items-center justify-center hover:scale-110 transition-transform"><Heart className="w-4 h-4 fill-red-500 text-red-500" /></button>
                <img src={fileUrl(a.image)} alt={a.name} onClick={() => nav(`/activites/${a.id}`)} className="w-full h-44 object-cover cursor-pointer" />
                <div className="p-4">
                  <p onClick={() => nav(`/activites/${a.id}`)} className="font-heading font-bold text-ink cursor-pointer hover:text-canard transition-colors">{a.name}</p>
                  <p className="text-sm text-muted2 mt-1 line-clamp-2">{a.description}</p>
                  <span className="text-sm font-bold text-canard mt-2 inline-block">{t("activities.from")} {a.price_from}€</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
